// Builds the CSAT rating distribution segments, ordered from the best rating
// to the worst, with percentages of the total responses.
export const buildRatingSegments = (ratings, ratingCount = {}, total = 0) =>
  [...ratings]
    .sort((a, b) => b.value - a.value)
    .map(rating => {
      const value = Number(ratingCount?.[rating.value]) || 0;
      const percentage =
        total > 0 ? Math.round((value / total) * 1000) / 10 : 0;
      return {
        id: rating.key,
        translationKey: rating.translationKey,
        emoji: rating.emoji,
        color: rating.color,
        value,
        percentage,
      };
    });
